import Footer from "../components/Footer";
import Pickaxe from '../assets/pickaxe.png';
import GemA from '../assets/aquaGem.png';
import GemB from '../assets/gemB.png'
import Logo from '../assets/logo.png';
import Twitter from '../assets/twitter.png';
import Telegram from '../assets/telegram.png';
import Friends from '../assets/friends.png';
import Check from '../assets/check.png';
import Play from '../assets/play-button.png';
import { useState, useEffect } from 'react';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useUser } from '../utils/UserContext';
import Claimed from '../assets/claimed.png';
import EarnStar from '../assets/earnStar.png';
import REJECTICON from '../assets/remove.png';
import './Home.css';
import Android from '../assets/android.png';
import Ios from '../assets/ios.png';
import { motion } from "framer-motion";
import Reward from '../assets/reward.mp4';
import RewardA from '../assets/rewardA.json'
import { Player } from "@lottiefiles/react-lottie-player";
import styled from "styled-components";
import Rejected from '../assets/rejected.png';
import SUCCESSICON from '../assets/checkmark.png';
import VERIFYICON from '../assets/privacy.png';



const Container = {
    width: '100%',
    height: 'auto',
    background: '#060514',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    fontFamily: 'Space Grotesk, Sans Serif',
};

const RewardWrapperA = {
    width: '85%',
    maxWidth: '85%',
    padding: '20px 10px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '10px auto',
    borderBottom: '1px solid rgba(255, 255, 255, 0.2)'
};

const RewardWrapperRow = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '15px',
};

const ButtonH = {
    padding: '7.5px 0px',
    background: '#007acc', 
    borderRadius: '10px',
    width: '100%',
    border: '2px solid #007acc',
    fontWeight: '700',
    fontSize: '12px',
    cursor: 'pointer',
    transition: 'transform 0.3s ease, background-color 0.3s ease',
    textAlign: 'center',
    boxShadow: '0 5px 10px rgba(0, 0, 0, 0.5)',
    marginTop: '20px',
    textDecoration: 'none',
    ':hover': {
        backgroundColor: '#444444',
        transform: 'scale(1.05)',
    },
};

const RewardImageContainer = {
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '2px solid #007acc',
    borderRadius: '50%',
    padding: '10px',
    marginBottom: '20px',
    };

const ModalIcon = styled.img`
    margin-top: 20px;
    margin-bottom: 20px;
    `
const ModalTopTitle = styled.div`
    color: rgba(0, 0, 0, 0.95);
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 20px;
    `
const ModalSubTitle = styled.div`
    color: rgba(0, 0, 0, 0.75);
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    margin-bottom: 20px;
    `

const RewardWrapper = {
    width: '25px',
    height: '25px',
}

const RewardImageA = {
    height: '27.5px',
    width: '27.5px',
    objectFit: 'cover',
};

const RewardColumn = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '10px',
};

const RewardWrapperBigText = {
    fontSize: '13px',
    color: '#dfe6f0',
    fontWeight: '600',
    span: {
        color: '#FFC107', 
    },
};

const RewardWrapperRowA = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '10px',
};

const RewardWrapperSmallTextA = {
    fontSize: '14px',
    color: '#FFC107',
    fontWeight: '600',
    textShadow: '1px 1px 2px rgba(0, 0, 0, 0.6)',
};

const GemImageWrapper = {
    height: '25px',
    width: '25px',
    objectFit: 'contain',
};

const Button = {
    padding: '7.5px 10px',
    backgroundColor: '#007acc',
    borderRadius: '10px',
    border: '2px solid #007acc',
    cursor: 'pointer',
    transition: 'transform 0.3s ease, background-color 0.3s ease',
    textAlign: 'center',
    boxShadow: '0 5px 10px rgba(0, 0, 0, 0.5)',
    ':hover': {
        backgroundColor: '#444444',
        transform: 'scale(1.05)',
    },
};

const ButtonText = {
    fontSize: '12px',
    color: '#e0e0e0',
    fontWeight: '700',
    textAlign: 'center',
};

const RewardImage = {
    width: '32.5px',
    height: '32.5px',
};

const RewardImageC = {
    width: '32.5px',
    
};



const RewardMainWrapper = {
    marginBottom: '40px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: '15px',
    border: '1px solid rgba(0, 122, 204, 0.5)',
    backgroundColor: 'rgba(0, 122, 204, 0.05)',    
    marginTop: '10px',
    padding: '5px',
    width: '90%',
    boxShadow: '0 5px 10px rgba(0, 0, 0, 0.5)',


};

const RewardMainWrapperB = {
    marginBottom: '100px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: '15px',
    backgroundColor: 'rgba(0, 122, 204, 0.05)',
    border: '1px solid rgba(0, 122, 204, 0.5)',
    marginTop: '10px',
    padding: '5px',
    width: '90%',
    boxShadow: '0 5px 10px rgba(0, 0, 0, 0.5)',


};

const PageHeaderWrapper = {
    width: '100%',
    padding: '20px 0',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
};

const PageHeaderRow = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '20px',
};

const PageHeaderText = {
    fontSize: '24px',
    color: 'white',
    fontWeight: '700',
    marginBottom: '20px',
};

const PageHeaderSubText = {
    fontSize: '12px',
    color: '#c1cade',
    fontWeight: '500',
    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.8)',
    marginLeft: '20px',


};

const ProgressBar = {
    width: '80%',
    height: '10px',
    margin: '15px auto',
    appearance: 'none',
    backgroundColor: '#333333',
    borderRadius: '5px',
    overflow: 'hidden',
    boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.5)',
};

ProgressBar["::-webkit-progress-bar"] = {
    backgroundColor: '#333333',
    borderRadius: '5px',
};

ProgressBar["::-webkit-progress-value"] = {
    backgroundColor: '#02797d',
    borderRadius: '5px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.6)',
};

const TitleRow = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '90%',
};


const SectionTitle = {
    fontSize: '18px',
    color: 'white',
    fontWeight: '600',
    marginLeft: '10px',
    zIndex: '30',
};

const SectionSubTitle = {
    fontSize: '14px',
    color: '#c1cade',
    fontWeight: '600',
    marginTop: '5px',
    
};

const RewardModalBackground = {
    position: 'absolute',
    left: '0',
    top: '0',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: '#414068',
};

const VerifyAppBackground = {
    position: 'fixed',  
    left: '0',
    top: '0',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center', 
    background: 'rgba(6, 5, 20, 0.75)', 
    zIndex: '998', 
};

const VerifyAppDownload = {
    width: '80%',
    padding: '20px',
    borderRadius: '10px',
    boxShadow: '0 5px 10px rgba(0, 0, 0, 0.5)',
    background: '#eee',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: '999',
};

const inputStyle = {
    width: "90%",
    padding: "10px",
    borderRadius: "15px",
    margin: '10px 0px',
    fontSize: "12px",
    border: "1px solid rgba(0, 122, 204, 0.1)",
    background: "rgba(0, 122, 204, 0.1)",
    fontFamily: 'Space Grotesk, Sans Serif',
    color: "white",
  };

const AppImageRow = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '20px',
};

const AppTextRow = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '20px',
    
}; 

const AppLittleText = {
    fontSize: '10px',
    color: '#c1cade',
    fontWeight: '500',
    fontFamily: 'Space Grotesk, Sans Serif',
    background: 'transparent',
    border: '2px solid transparent',
    marginTop: '10px',
}

const TopTitle = styled.div`
    color: white;
    font-size: 36px;
    font-weight: 700;
    margin-bottom: 10px;
    `
const TopSubTitle = styled.div`
    color: #c1cade;
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 10px;
    text-align: center;
    `

const Earn = () => {

    const { user } = useUser();
    const [userData, setUserData] = useState(null);
    const [result, setResult] = useState(null);
    const [resultA, setResultA] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [userIdForTG, setUserIdForTG] = useState(null);
    const [isAnnounceClaimed, setIsAnnounceClaimed] = useState(false);
    const [isCommunityClaimed, setIsCommunityClaimed] = useState(false);
    const [isNameChecked, setIsNameChecked] = useState(false);
    const [scriptLoaded, setScriptLoaded] = useState(false);
    const [isTwitterFollow, setIsTwitterFollow] = useState(false);
    const [trueCount, setTrueCount] = useState(0); // stores value of localStorage.item count
    const [isRewardModalOpen, setIsRewardModalOpen] = useState(false);
    const [isFiveInTeam, setIsFiveInTeam] = useState(false);
    const [isTenInTeam, setIsTenInTeam] = useState(false);
    const [isVerifyAppOpen, setIsVerifyAppOpen] = useState(false);
    const [appUsername, setAppUsername] = useState("");
    const [appEmail, setAppEmail] = useState("");
    const [isDownloadVerified, setIsDownloadVerified] = useState(false);
    const [message, setMessage] = useState(null);
    const [rewardValue, setRewardValue] = useState(null); // stores the value of the reward to display
    const [isRejectionModalOpen, setIsRejectionModalOpen] = useState(false);



//////////////////////////////////////////////////////////////////////////////////////////

////////////// handles form to verify android account ////////////////////////////////////


const handleAppSubmit = async (e) => {
    e.preventDefault();
    console.log("Username:", appUsername);
    console.log("Email:", appEmail);

    try {
        const response = await axios.post('https://chainfree.info:5000/verify-app-user', {
            username: appUsername,
            email: appEmail,
        });

        console.log("Full Response Data:", JSON.stringify(response.data, null, 2));

        if (response.data.success) {
            setMessage("User verified!");
            localStorage.setItem('download_verified', 'true');
            setIsDownloadVerified(true);
            setIsVerifyAppOpen(false);

            const rewardAmount = 100;
            setRewardValue(rewardAmount);
            setIsRewardModalOpen(true);

            await axios.post(
                'https://chainfree.info:5000/updateReward',
                { rewardAmount },
                { params: { userId: user.id } }
            );

            await axios.get('https://chainfree.info:5000/verify-user-download', {
                params: { userId: user.id },
            });

        } else {
            console.log("Else block reached"); // Debug if else block executes
            const errorMessage = response.data.message || "Unknown error occurred";
            setMessage(errorMessage);
            console.log("Error Message:", errorMessage);
        }

    } catch (error) {
        console.error("AxiosError:", error);

        
        if (error.response && error.response.data && error.response.data.message) {
            console.log("Caught Error Message:", error.response.data.message);
            setMessage(error.response.data.message);
        } else {
            console.log("Generic error message");
            setMessage("An error occurred. Please try again.");
        }

        localStorage.setItem('download_verified', 'false');
        setIsRejectionModalOpen(true);
    }
};



//////////////////////////////////////////////////////////////////////////////////////////

///////////////// checks localStorage for how many are true //////////////////////////////

useEffect(() => {
    // Define the specific keys you want to check
    const appKeys = ["twitter_follow", "download_verified", "name_check", "announce_claimed", "community_claimed", "team_five", "team_ten"]; // Replace these with your actual keys

    const countTrueLocalStorageItems = () => {
      let count = 0;

      appKeys.forEach((key) => {
        // Check if the item exists and is set to "true"
        if (localStorage.getItem(key) === "true") {
          count++;
        }
      });

      return count;
    };

    setTrueCount(countTrueLocalStorageItems());
  }, []);



///////////////////////////////////////////////////////////////////////////////////////////

////////////////// checks localStorage for isTwitterFollow ////////////////////////////////

useEffect(() => {
    // Check if the 'announce_claimed' value exists in localStorage
    const storedTwitterFollow = localStorage.getItem('twitter_follow');
    
    // If it's 'true', update the state to reflect the green tick
    if (storedTwitterFollow === 'true') {
        setIsTwitterFollow(true);
    }
}, []);

//////////////////////////////////////////////////////////////////////////////////////////////

////////////////// checks localStorage for downloadVerified ////////////////////////////////

useEffect(() => {
    // Check if the 'announce_claimed' value exists in localStorage
    const storedDownloadVerified = localStorage.getItem('download_verified');
    
    // If it's 'true', update the state to reflect the green tick
    if (storedDownloadVerified === 'true') {
        setIsDownloadVerified(true);
    }
}, []);

////////////////// checks localstorage for isNameChecked //////////////////////////////////

useEffect(() => {
    // Check if the 'announce_claimed' value exists in localStorage
    const storedNameCheck = localStorage.getItem('name_check');
    
    // If it's 'true', update the state to reflect the green tick
    if (storedNameCheck === 'true') {
        setIsNameChecked(true);
    }
}, []);

    
////////////////////////////////////////////////////////////////////////////////////////////

/////////////////////////////  checks localStorage for isAnnouncedClaimed ///////////////////

    useEffect(() => {
        // Check if the 'announce_claimed' value exists in localStorage
        const storedAnnounceClaimedValue = localStorage.getItem('announce_claimed');
        
        // If it's 'true', update the state to reflect the green tick
        if (storedAnnounceClaimedValue === 'true') {
            setIsAnnounceClaimed(true);
        }
    }, []);

//////////////////////////////////////////////////////////////////////////////////////////////

//////////////////////// checks localStorage for isCommunityClaimed  ///////////////////////

useEffect(() => {
    // Check if the 'announce_claimed' value exists in localStorage
    const storedCommunityClaimedValue = localStorage.getItem('community_claimed');
    
    // If it's 'true', update the state to reflect the green tick
    if (storedCommunityClaimedValue === 'true') {
        setIsCommunityClaimed(true);
    }
}, []);

//////////////////////////////////////////////////////////////////////////////////////////////

/////////////////////// checks localStorage for isFiveInTeam /////////////////////////////////

useEffect(() => {
    // Check if the 'announce_claimed' value exists in localStorage
    const storedFiveInTeam = localStorage.getItem('team_five');
    
    // If it's 'true', update the state to reflect the green tick
    if (storedFiveInTeam === 'true') {
        setIsFiveInTeam(true);
    }
}, []);

//////////////////////////////////////////////////////////////////////////////////////////////

/////////////////////// checks localStorage for isTenInTeam //////////////////////////////////

useEffect(() => {
    // Check if the 'announce_claimed' value exists in localStorage
    const storedTenInTeam = localStorage.getItem('team_ten');
    
    // If it's 'true', update the state to reflect the green tick
    if (storedTenInTeam === 'true') {
        setIsTenInTeam(true);
    }
}, []);

//////////////////////////////////////////////////////////////////////////////////////////////

///////////////////////////// checks if memeber of announcement channel and gives reward /////

    const checkMembershipAnnouncements = async () => {
        if (!user) {
          setError('Please enter a user ID.');
          return;
        }
    
        setError(null);
        
    
        try {
          const response = await axios.get('https://chainfree.info:5000/check-membership', {
            params: { userId: user.id },
          });
    
          const data = response.data;
    
          if (data.success) {
            setResult(data.message);

            if (data.success) {
                localStorage.setItem('announce_claimed', 'true');
                setIsAnnounceClaimed(true);

                const rewardAmount = 20;
                setRewardValue(rewardAmount);
                setIsRewardModalOpen(true);

                const rewardResponse = await axios.post(
                    'https://chainfree.info:5000/updateReward',
                    {
                        rewardAmount: 20, // Add 10 to the reward balance
                    },
                    {
                        params: { userId: user.id }, // Make sure to include the user ID
                    }
                );

                // Optionally, handle the response of the reward update
                if (rewardResponse.status === 200) {
                    console.log('User reward balance updated successfully');
                } else {
                    console.error('Failed to update reward balance');
                }
            } else {
                localStorage.setItem('announce_claimed', 'false');
                const userResponse = "You must first join the announcement channel"
                setMessage(userResponse);
                setIsRejectionModalOpen(true);
            }
          } else {
            setResult(data.message);
          }
        } catch (err) {
          setError('An error occurred while checking membership.');
          console.error(err.message);
        } finally {
          setLoading(false);
        }
      };

////////////////////////////////////////////////////////////////////////////////////////////////////

/////////////////// checkd if member of community chat /////////////////////////////////////////////

const checkMembershipCommunity = async () => {
    if (!user) {
      setError('Please enter a user ID.');
      return;
    }

    setError(null);
    

    try {
      const response = await axios.get('https://chainfree.info:5000/check-membership-community', {
        params: { userId: user.id },
      });

      const data = response.data;

      if (data.success) {
        setResultA(data.message);

        if (data.success) {
            localStorage.setItem('community_claimed', 'true');
            setIsCommunityClaimed(true);

            const rewardAmount = 10;
            setRewardValue(rewardAmount);
            setIsRewardModalOpen(true);

            const rewardResponse = await axios.post(
                'https://chainfree.info:5000/updateReward',
                {
                    rewardAmount: 10, // Add 10 to the reward balance
                },
                {
                    params: { userId: user.id }, // Make sure to include the user ID
                }
            );

            // Optionally, handle the response of the reward update
            if (rewardResponse.status === 200) {
                console.log('User reward balance updated successfully');
            } else {
                console.error('Failed to update reward balance');
            }
        } else {
            localStorage.setItem('community_claimed', 'false');
        }
      } else {
        setResultA(data.message);
      }
    } catch (err) {
      setError('An error occurred while checking membership.');
      console.error(err.message);
    } finally {
      setLoading(false);
    }
  };


    const Navigate = useNavigate();

    const handleInviteClick = () => {
        Navigate("/invite");
    }
    

    //////////////////////// check if twitter following ////////////////////

    const handleTwitterFollow = async () => {
        if (!scriptLoaded) {
          // Dynamically load the Twitter follow button script
          const script = document.createElement('script');
          script.src = 'https://platform.twitter.com/widgets.js';
          script.async = true;
          script.onload = () => setScriptLoaded(true); // Set state when script is loaded
          document.body.appendChild(script);
        }
      
        // Open Twitter in a new tab (for the follow prompt)
        window.open('https://twitter.com/hydrixapp', '_blank');
        localStorage.setItem('twitter_follow', 'true');
        setIsTwitterFollow(true);

            const rewardAmount = 20;
            setRewardValue(rewardAmount);
            setIsRewardModalOpen(true);
      
        try {
          // Update the user's reward balance
          const rewardResponse = await axios.post(
            'https://chainfree.info:5000/updateReward',
            {
              rewardAmount: 20, // Add 15 to the reward balance
            },
            {
              params: { userId: user.id }, // Make sure to include the user ID
            }
          );
      
          // Optionally, handle the response of the reward update
          if (rewardResponse.status === 200) {
            console.log('User reward balance updated successfully');
          } else {
            console.error('Failed to update reward balance');
          }
      
          // Send a request for additional action (if needed)
          const response = await axios.get('https://chainfree.info:5000/twitter-follow', {
            params: { userId: user.id },
          });
      
          // Optionally, handle the response of the follow action
          if (response.status === 200) {
            console.log('Twitter follow action recorded');
          } else {
            console.error('Failed to record the follow action');
            localStorage.setItem('twitter_follow', 'false');
            const userResponse = "You are not following Hydrix"
            setMessage(userResponse);
            setIsRejectionModalOpen(true);
          }
      
        } catch (error) {
          console.error('Error during API requests:', error);
        }
      };
      
  

//////////////////////////////////////////////////////////////////////////////////////////////

/////////// is hydrix in telegram username //////////////////////////////////////////////////

const handleNameCheck = async () => {
    const username = user.username.toLowerCase(); // Convert to lowercase for case-insensitive comparison
    const containsHydrix = username.includes('hydrix'); // Check if 'hydrix' is in the username
  
    if (containsHydrix) {
      console.log('Hydrix is in the username');
      localStorage.setItem('name_check', 'true');
      setIsNameChecked(true);

        const rewardAmount = 30; // Set reward amount dynamically
        setRewardValue(rewardAmount); // Update state to display in modal
        setIsRewardModalOpen(true); // Open the reward modal

      const rewardResponse = await axios.post(
        'https://chainfree.info:5000/updateReward',
        {
            rewardAmount: 30, // Add 10 to the reward balance
        },
        {
            params: { userId: user.id }, // Make sure to include the user ID
        }
    );

    // Optionally, handle the response of the reward update
    if (rewardResponse.status === 200) {
        console.log('User reward balance updated successfully');
    } else {
        console.error('Failed to update reward balance');
    }

    const response = await axios.get('https://chainfree.info:5000/name-check', {
        params: { userId: user.id },
      })
    } else {
      console.log('Hydrix is not in the username');
      localStorage.setItem('name_check', 'false');
      const userResponse = "Hydrix is not in your telegram username"
      setMessage(userResponse);
      setIsRejectionModalOpen(true);
    }
  };

const MaxProgress = 8;
const EarnProgress = trueCount / MaxProgress; 

//////////////////////////////////////////////////////////////////////////////////////////////////

/////////////////////// fetch userData on page render ///////////////////////////////////////////

const fetchUserData = async () => {
    try {
        const response = await axios.get(`https://chainfree.info:5000/user`);
        setUserData(response.data.userData);
        console.log('userData', response.data.userData);
        setError(null); 
    } catch (error) {
        setError(error.message);
    }
};

useEffect(() => {
    fetchUserData();
  }, []);

/////////////////////////////////////////////////////////////////////////////////////////////////////

////////////////////////////// check if team size is => 5 ///////////////////////////////////////////

const verifyTeamSize = async () => {
    if (userData?.team >= 5) {
      console.log("Team has 5 or more members!");

      const rewardResponse = await axios.post(
        'https://chainfree.info:5000/updateReward',
        {
            rewardAmount: 30, // Add 10 to the reward balance
        },
        {
            params: { userId: user.id }, // Make sure to include the user ID
        }
    );

    localStorage.setItem('team_five', 'true');
    setIsFiveInTeam(true);

            const rewardAmount = 30;
            setRewardValue(rewardAmount);
            setIsRewardModalOpen(true);
      
    } else {
        const userResponse = "Team does not have at least 5 members."
        setMessage(userResponse);
        console.log("Team does not have enough members.");
        setIsRejectionModalOpen(true);
        localStorage.setItem('team_five', 'false');
    }

    const response = await axios.get('https://chainfree.info:5000/five_in_team', {
        params: { userId: user.id }
    });
  };

//////////////////////////////////////////////////////////////////////////////////////////////////////

//////////////////////////// check if teamsize => 10 /////////////////////////////////////////////////


const verifyTeamSizeA = async () => {
    if (userData?.team >= 10) {
      console.log("Team has 10 or more members!");

      const rewardResponse = await axios.post(
        'https://chainfree.info:5000/updateReward',
        {
            rewardAmount: 75, // Add 10 to the reward balance
        },
        {
            params: { userId: user.id }, // Make sure to include the user ID
        }
    );

    localStorage.setItem('team_ten', 'true');
    setIsTenInTeam(true);

            const rewardAmount = 75;
            setRewardValue(rewardAmount);
            setIsRewardModalOpen(true);

    const response = await axios.get('https://chainfree.info:5000/ten_in_team', {
        params: { userId: user.id }
    });
    } else {
        const userResponse = "Team does not have at least 10 members."
        setMessage(userResponse);
        console.log("Team does not have 10 or more members.");
        setIsRejectionModalOpen(true);
        localStorage.setItem('team_ten', 'false');
    }
  };


    


    return (
        <div style={Container}>
            <div style={PageHeaderWrapper}>
                <div style={PageHeaderText}>Rewards Center</div>
                <div style={PageHeaderRow}>
                    <img src={EarnStar} />
                    <div style={PageHeaderSubText}>Completed Tasks: {trueCount}/8</div>
                </div>
                <progress value={EarnProgress} className="custom-progress-bar" />
            </div>
            <div style={TitleRow}>
                <img src={EarnStar} />
                <div style={SectionTitle}>Follow Tasks</div>
            </div>
            <div style={TitleRow}>
                <div style={SectionSubTitle}>Earn Gems for following our socials!</div>
            </div>
            <div style={RewardMainWrapper}>
                <div style={RewardWrapperA}>
                        <div style={RewardWrapperRow}>
                            <div style={RewardImageContainer}>
                                <img src={Twitter} style={RewardImageA} />
                            </div>
                            <div style={RewardColumn}>
                                <div style={RewardWrapperBigText}>Follow on X</div>
                                <div style={RewardWrapperRowA}>
                                    <div style={RewardWrapperSmallTextA}>+ 20</div>
                                    <img src={GemA} style={GemImageWrapper} />
                                </div>
                            </div>
                        </div>
    {isTwitterFollow ? (
                        <motion.img 
                            src={Claimed}
                            initial={{ opacity: 0, scale: 0.8 }} 
                            animate={{ opacity: 1, scale: 1 }} 
                            transition={{ duration: 0.3, ease: "easeOut" }} 
                        />
    ) : (
                        <button style={Button} onClick={handleTwitterFollow}>
                            <div style={ButtonText}>Follow</div>
                        </button>
    )}
                    
                    </div>
                    <div style={RewardWrapperA}>
                <div style={RewardWrapperRow}>
                    <div style={RewardImageContainer}>
                        <img src={Telegram} style={RewardImageA} />
                    </div>
                    <div style={RewardColumn}>
                        <div style={RewardWrapperBigText}>Join TG announcements</div>
                        <div style={RewardWrapperRowA}>
                            <div style={RewardWrapperSmallTextA}>+ 20</div>
                            <img src={GemA} style={GemImageWrapper} />
                        </div>
                        <a href="https://t.me/HydrixApp" target="_blank" rel="noopener noreferrer">
                            Join telegram
                        </a>
                </div>
                </div>
{isAnnounceClaimed ? (
                <motion.img 
                    src={Claimed}
                    initial={{ opacity: 0, scale: 0.8 }} 
                    animate={{ opacity: 1, scale: 1 }} 
                    transition={{ duration: 0.3, ease: "easeOut" }} 
                />
) : (
                <button style={Button} onClick={checkMembershipAnnouncements}> 
                    <div style={ButtonText}>Verify</div>
                </button>
)}
            </div>
            <div style={{ ...RewardWrapperA, borderBottom: "none" }}>                
                <div style={RewardWrapperRow}>
                    <div style={RewardImageContainer}>
                        <img src={Telegram} style={RewardImageA} />
                    </div>
                    <div style={RewardColumn}>
                        <div style={RewardWrapperBigText}>Join Community TG</div>
                        <div style={RewardWrapperRowA}>
                            <div style={RewardWrapperSmallTextA}>+ 10</div>
                            <img src={GemA} style={GemImageWrapper} />
                        </div>
                    </div>
                </div>
{isCommunityClaimed ? (
                <motion.img 
                    src={Claimed}
                    initial={{ opacity: 0, scale: 0.8 }} 
                    animate={{ opacity: 1, scale: 1 }} 
                    transition={{ duration: 0.3, ease: "easeOut" }} 
                />
) : (
                <button style={Button} onClick={checkMembershipCommunity}>
                    <div style={ButtonText}>Soon</div>
                </button>
)}
            </div>
            </div>
            <div style={TitleRow}>
                <img src={EarnStar} />
                <div style={SectionTitle}>Invite Tasks</div>
            </div>
            <div style={TitleRow}>
                <div style={SectionSubTitle}>Invite your friends and family!</div>
            </div>
            <div style={RewardMainWrapper}>
            <div style={RewardWrapperA}>
                <div style={RewardWrapperRow}>
                    <div style={RewardImageContainer}>
                        <img src={Friends} style={RewardImageA} />
                    </div>
                    <div style={RewardColumn}>
                        <div style={RewardWrapperBigText}>Invite 5 friends</div>
                        <div style={RewardWrapperRowA}>
                            <div style={RewardWrapperSmallTextA}>+ 15</div>
                            <img src={GemA} style={GemImageWrapper} />
                        </div>
                    </div>
                </div>
{isFiveInTeam ? (
                <motion.img 
                    src={Claimed}
                    initial={{ opacity: 0, scale: 0.8 }} 
                    animate={{ opacity: 1, scale: 1 }} 
                    transition={{ duration: 0.3, ease: "easeOut" }} 
                />
            ) : (
                <button style={Button} onClick={verifyTeamSize}>
                    <div style={ButtonText}>Verify</div>
                </button>
            )}
                
            </div>
            <div style={{ ...RewardWrapperA, borderBottom: "none" }}>                
                <div style={RewardWrapperRow}>
                    <div style={RewardImageContainer}>
                        <img src={Friends} style={RewardImageA} />
                    </div>
                    <div style={RewardColumn}>
                        <div style={RewardWrapperBigText}>Invite 10 friends</div>
                        <div style={RewardWrapperRowA}>
                            <div style={RewardWrapperSmallTextA}>+ 35</div>
                            <img src={GemA} style={GemImageWrapper} />
                        </div>
                    </div>
                </div>
{isTenInTeam ? (
                <motion.img 
                    src={Claimed}
                    initial={{ opacity: 0, scale: 0.8 }} 
                    animate={{ opacity: 1, scale: 1 }} 
                    transition={{ duration: 0.3, ease: "easeOut" }} 
                />
            ) : (
                <button style={Button} onClick={verifyTeamSizeA}> 
                    <div style={ButtonText}>Verify</div>
                </button>
)}
               
            </div>
            </div>
            <div style={TitleRow}>
                <img src={EarnStar} />
                <div style={SectionTitle}>Extra Tasks</div>
            </div>
            <div style={TitleRow}>
                <div style={SectionSubTitle}>Earn extra gems</div>
            </div>
            <div style={RewardMainWrapperB}>
                <div style={RewardWrapperA}>
                    <div style={RewardWrapperRow}>
                        <div style={RewardImageContainer}>
                            <img src={Logo} style={RewardImageC} />
                        </div>
                        <div style={RewardColumn}>
                            <div style={RewardWrapperBigText}>Add Hydrix to username</div>
                            <div style={RewardWrapperRowA}>
                                <div style={RewardWrapperSmallTextA}>+ 30</div>
                                <img src={GemA} style={GemImageWrapper} />
                            </div>
                        </div>
                    </div>
{isNameChecked ? ( 
                    <motion.img 
                        src={Claimed}
                        initial={{ opacity: 0, scale: 0.8 }} 
                        animate={{ opacity: 1, scale: 1 }} 
                        transition={{ duration: 0.3, ease: "easeOut" }} 
                    />
) : (
                    <button style={Button} onClick={handleNameCheck}> 
                        <div style={ButtonText}>Verify</div>
                    </button>
)}
                   
                </div>
                
            <div style={RewardWrapperA}>
                <div style={RewardWrapperRow}>
                    <div style={RewardImageContainer}>
                        <img src={Play} style={RewardImageA} />
                    </div>
                    <div style={RewardColumn}>
                        <div style={RewardWrapperBigText}>Watch an ad</div>
                        <div style={RewardWrapperRowA}>
                            <div style={RewardWrapperSmallTextA}>+ 2</div>
                            <img src={GemA} style={GemImageWrapper} />
                        </div>
                    </div>
                </div>
                <button style={Button}>
                    <div style={ButtonText}>Coming soon</div>
                </button>
            </div>
            
           
            
            <div style={{ ...RewardWrapperA, borderBottom: "none" }}>                
                <div style={RewardWrapperRow}>
                    <div style={RewardImageContainer}>
                        <img src={Check} style={RewardImageA} />
                    </div>
                    <div style={RewardColumn}>
                        <div style={RewardWrapperBigText}>Download the app</div>
                        <div style={RewardWrapperRowA}>
                            <div style={RewardWrapperSmallTextA}>+ 100</div>
                            <img src={GemA} style={GemImageWrapper} />
                        </div>
                    </div>
                </div>
{isDownloadVerified ? (
              <motion.img 
                src={Claimed}
                initial={{ opacity: 0, scale: 0.8 }} 
                animate={{ opacity: 1, scale: 1 }} 
                transition={{ duration: 0.3, ease: "easeOut" }} 
            />
            ) : (
                <button style={Button} onClick={() => setIsVerifyAppOpen(true)}>
                    <div style={ButtonText}>Verify</div>
                </button>
)}
                
            </div>
            </div>

{isVerifyAppOpen && (
            <div style={VerifyAppBackground} onClick={() => setIsVerifyAppOpen(false)}>
                <form style={VerifyAppDownload} onSubmit={handleAppSubmit} onClick={(e) => e.stopPropagation()}>
                <ModalIcon src={VERIFYICON} />
                <div style={AppTextRow}>
                    <ModalSubTitle>Input your android or ios username
                    and email to verify your account</ModalSubTitle>
                </div>
                <input
                    type="text"
                    placeholder="Username"
                    value={appUsername}
                    onChange={(e) => setAppUsername(e.target.value)}
                    style={inputStyle}
                    required
                />
                <input
                    type="email"
                    placeholder="email"
                    value={appEmail}
                    onChange={(e) => setAppEmail(e.target.value)}
                    style={inputStyle}
                    required
                />
                <button type="submit" style={ButtonH} onClick={handleAppSubmit}>
                    <div style={ButtonText}>Verify</div>
                </button>

                </form>
               
            </div>
)}
{isRewardModalOpen && (
    <motion.div 
            initial={{ y: "100%" }} 
            animate={{ y: "0%" }} 
            transition={{ duration: 0.5, ease: "easeInOut" }}
            style={{
                position: "fixed",
                top: "25%",
                width: "80%",
                background: "#eee",
                borderRadius: "10px",
                boxShadow: "0 -4px 10px rgba(0, 0, 0, 0.2)",
                display: "flex",
                flexDirection: 'column',
                alignItems: "center",
                justifyContent: "center",
                zIndex: "999",
            }}
            onClick={() => setIsRewardModalOpen(false)}
        >
            <ModalIcon src={SUCCESSICON} />
            <ModalTopTitle>Congratulations!</ModalTopTitle>
            <ModalSubTitle style={{ width: '80%' }}>You have been rewarded {rewardValue} Gems</ModalSubTitle>
            <ModalSubTitle style={{ width: '80%' }}>Earn more Gems by completing other tasks!</ModalSubTitle>
            
    </motion.div>
)}
{isRejectionModalOpen && (
    <motion.div 
            initial={{ y: "100%" }} 
            animate={{ y: "0%" }} 
            transition={{ duration: 0.5, ease: "easeInOut" }}
            style={{
                position: "fixed",
                top: "25%",
                width: "80%",
                background: "#eee",
                borderRadius: "10px",
                boxShadow: "0 -4px 10px rgba(0, 0, 0, 0.2)",
                display: "flex",
                flexDirection: 'column',
                alignItems: "center",
                justifyContent: "center",
                zIndex: "999",
            }}
            onClick={() => setIsRejectionModalOpen(false)}
        >
            <ModalIcon src={REJECTICON} />
            <ModalTopTitle>Oops!</ModalTopTitle>
            <ModalSubTitle style={{ width: '80%' }}>It appears that something isn't quite right?</ModalSubTitle>
            <ModalSubTitle style={{ width: '80%' }}>{message}</ModalSubTitle>
            
    </motion.div>
)}
            
            
           
            <Footer />
        </div>

    )
};

export default Earn;